<script>
  export let name;
</script>

<style>
  svg {
    stroke: currentColor;
    fill: none;
    height: 1em;
    width: 1em;
    z-index: 1;
  }
</style>

<svg
  class="icon"
  version="1.1"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink">

  {#if name == 'drawCard'}
    <g stroke-linecap="round" stroke-width="1.5" stroke-linejoin="round">
      <path
        d="M9.75,19.11l-2.879,1.049l-3.82393e-08,1.38953e-08c-0.778615,0.282931
        -1.63917,-0.1189 -1.9221,-0.897515c-0.000300886,-0.000828027
        -0.000601043,-0.00165632
        -0.00090047,-0.00248488l-4.107,-11.271l2.47817e-08,6.81982e-08c-0.282931,-0.778615
        0.1189,-1.63917 0.897515,-1.9221c0.000828027,-0.000300887
        0.00165632,-0.000601043 0.00248488,-0.000900471l6.509,-2.373" />
      <path
        d="M18.75,12.75v-10.5v0c0,-0.828427 -0.671573,-1.5
        -1.5,-1.5h-7.5l-6.55671e-08,1.77636e-15c-0.828427,3.62117e-08
        -1.5,0.671573 -1.5,1.5c0,0 0,0
        0,0v12l1.77636e-14,2.26494e-07c1.25089e-07,0.828427 0.671573,1.5
        1.5,1.5h0.75" />
      <path
        d="M15.091,6.65901c0.87868,0.87868 0.87868,2.3033
        0,3.18198c-0.87868,0.87868 -2.3033,0.87868 -3.18198,0c-0.87868,-0.87868
        -0.87868,-2.3033 0,-3.18198c0.87868,-0.87868 2.3033,-0.87868 3.18198,0" />
      <path
        d="M17.92,22.7l2.32622e-08,-8.5272e-08c-0.109014,0.399611
        -0.521335,0.635187 -0.920946,0.526173c-0.241829,-0.0659709
        -0.434714,-0.248394
        -0.514054,-0.486173l-3.185,-8.488l-1.54112e-08,-4.61307e-08c-0.131248,-0.39287
        0.0808379,-0.817752 0.473708,-0.949c0.154241,-0.0515282
        0.321051,-0.0515282
        0.475292,5.21288e-08l8.485,3.182l-3.21092e-08,-1.07139e-08c0.392918,0.131105
        0.605159,0.55591 0.474054,0.948827c-0.0793398,0.237779
        -0.272224,0.420202 -0.514054,0.486173l-3.909,0.868Z" />
    </g>
  {/if}

  {#if name == 'shuffle'}
    <g stroke-linecap="round" stroke-width="1.5" stroke-linejoin="round">
      <path
        d="M10.1,9l1.75114e-07,2.35669e-07c-0.974216,-1.3111 -2.4709,-2.13318
        -4.1,-2.252h-5.25" />
      <path
        d="M23.25,6.748h-5.25c-3.75,0 -6,5.25 -6,5.25c0,0 -2.25,5.25
        -6,5.25h-5.25" />
      <path
        d="M13.9,15l4.87631e-08,6.55751e-08c0.974378,1.31031 2.4713,2.13107
        4.1,2.248h5.25" />
      <path d="M20.25,3.748l3,3l-3,3" />
      <path d="M20.25,14.248l3,3l-3,3" />
    </g>
  {/if}

</svg>
